// removed by extract-text-webpack-plugin
module.exports = {"profile":"profile_lwmDv"};


//////////////////
// WEBPACK FOOTER
// ./app/components/profile/styles.scss
// module id = 496
// module chunks = 1